import auditStatus from '../auditStatus'

const registerStep = Object.freeze({
  // Step 1
  personalInformation: 1.1,
  // Step 4
  accountConfiguration: 2.1,
  openAccountStatus: 2.2,
  // Step 5
  idInformation: 3.1,
  // this.currStep === registerStep.idInformation &&
  // this.poiAuditStatus === auditStatus.init &&
  // idNumber?.length > 0
  idUpload: 3.2,
  idStatus: 3.3,
  // Step 6
  poaInformation: 4.1,
  poaUpload: 4.2,
  poaStatus: 4.3,
  poaSuccess: 5.1,
})

export default registerStep

// Original user's registerStep
export const getUserStep = userStep => {
  switch (userStep) {
    case registerStep.personalInformation:
      return 1
    case registerStep.accountConfiguration:
      return 4
    case registerStep.openAccountStatus:
    case registerStep.idInformation:
    case registerStep.idUpload:
      return 5
    case registerStep.idStatus:
    case registerStep.poaInformation:
    case registerStep.poaUpload:
    case registerStep.poaStatus:
    case registerStep.poaSuccess:
      return 6
    default:
      break
  }
}

// registerStep enum
// substep determine in their particular parent component
export const getRegisterStep = (userStep, poaAuditStatus, poaPass) => {
  switch (userStep) {
    case 1:
      return registerStep.personalInformation
    case 4:
      return registerStep.accountConfiguration
    case 5:
      return registerStep.idInformation
    case 6: {
      if (!poaPass && poaAuditStatus === auditStatus.init) {
        return registerStep.poaInformation
      } else {
        return registerStep.poaSuccess
      }
    }
    default:
      return registerStep.personalInformation
  }
}
